module.exports = __webpack_public_path__ + "media/images/flavours/icon-fruit-exotique_dark-c5e34b3ed6acabe81ac8c54b8ff2a769.png";